const windowLocationPathname = window.location.pathname;
const landCode = windowLocationPathname.split('/')[1];
const countryCode = windowLocationPathname.split('/')[2];

const translatedText = {
  en: 'Close',
  ja: '閉じる',
  ko: '닫기',
  'zh-cn': '关闭',
  'zh-tw': '關閉',
  de: 'Schließen',
  fr: 'Fermer',
  th: 'ปิด',
  id: 'Tutup',
  'zh-hk': '關閉',
  vi: 'Đóng cửa',
};

export default class Close {
  /**
   * 「閉じる」ボタンの翻訳テキストを返します。
   * @example
   * import Close from '../lib/Close';
   * Close.text(); => '閉じる'
   */
  static text() {
    const isZh = landCode === 'zh';
    const closeText = !isZh
      ? translatedText[landCode]
      : translatedText[`${landCode}-${countryCode}`];
    return closeText;
  }
}
